import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { DashboardMarketingCard } from 'cpnl-common';
import { fetchDashboardMarketingCard } from './DashboardMarketingCardSlice';
import { DashboardMarketingCardContentSelector } from './DashboardMarketingCardContentSelector';

export function useDashboardMarketingCard(): AbstractContentState<DashboardMarketingCard> {
    return useCmsContent(fetchDashboardMarketingCard, DashboardMarketingCardContentSelector);
}
